
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 23.5C5.65926 23.5 0.5 18.3407 0.5 12C0.5 5.65926 5.65926 0.5 12 0.5C18.3407 0.5 23.5 5.65926 23.5 12C23.5 18.3407 18.3407 23.5 12 23.5ZM12 1.21423C6.05235 1.21423 1.21423 6.05235 1.21423 12C1.21423 17.9477 6.05235 22.7858 12 22.7858C17.9477 22.7858 22.7858 17.9477 22.7858 12C22.7858 6.05235 17.9477 1.21423 12 1.21423Z","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M16.0332 16.5383L16.033 16.5381L7.46166 7.96677C7.32197 7.82708 7.32211 7.60137 7.46157 7.462L7.46166 7.4619C7.60124 7.32232 7.82712 7.32242 7.96643 7.4618L7.96653 7.4619L16.5379 16.0332C16.6776 16.1729 16.6774 16.3986 16.538 16.538L16.5377 16.5383C16.4678 16.6082 16.3776 16.6429 16.2855 16.6429C16.1934 16.6429 16.103 16.6081 16.0332 16.5383Z","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M7.46186 16.5383L7.46157 16.538C7.32206 16.3986 7.32206 16.1728 7.46157 16.0333L7.46166 16.0332L16.033 7.46188C16.1727 7.32218 16.3984 7.32232 16.5378 7.46178L16.5379 7.46188C16.6775 7.60145 16.6774 7.82734 16.538 7.96665L16.5379 7.96674L7.96653 16.5381L7.96634 16.5383C7.89657 16.6081 7.80615 16.6429 7.714 16.6429C7.62197 16.6429 7.5317 16.6082 7.46186 16.5383Z","stroke":"currentColor"}})])
          )
        }
      }
    